import React from 'react';
import PropTypes from 'prop-types';
import {FormattedHTMLMessage, FormattedMessage} from 'react-intl';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

class HelpButton extends React.Component {
    constructor() {
        super();

        this.getTooltip = this.getTooltip.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleOpen = this.handleOpen.bind(this);

        this.state = {
            open: false
        };
    }

    getTooltip() {
        return (
            <div className="tooltip">
                <div>
                    <FormattedMessage id={this.props.briefMessageId}/>
                </div>
                {do {
                    if (this.props.detailedMessageId) {
                        <div
                            className="detailed"
                            onClick={this.state.open ? this.handleClose : this.handleOpen}
                        >
                            <div className="more">
                                <IconButton>{this.state.open ? <ExpandLessIcon/> : <ExpandMoreIcon/>}</IconButton>
                                <FormattedMessage id={this.state.open ? 'help.seeLess' : 'help.seeMore'}/>
                            </div>
                        </div>;
                    }
                }}
                {do {
                    if (this.props.detailedMessageId && this.state.open) {
                        <div className="details">
                            <FormattedHTMLMessage id={this.props.detailedMessageId}/>
                        </div>;
                    }
                }}
            </div>
        );
    }

    handleClose() {
        this.setState({open: false});
    }

    handleOpen() {
        this.setState({open: true});
    }

    render() {
        return (
            <div className="help-btn">
                <Tooltip
                    interactive={this.props.interactive}
                    leaveDelay={200}
                    leaveTouchDelay={200}
                    placement="bottom"
                    title={this.getTooltip()}
                >
                    <IconButton
                        aria-label={<FormattedMessage id={this.props.briefMessageId}/>}
                        color="secondary"
                        href={this.props.href}
                        onClick={this.props.contentMessageId ? this.handleOpen : null}
                        target={this.props.target}
                    >
                        <HelpOutlineIcon/>
                    </IconButton>
                </Tooltip>
                {do {
                    if (this.props.contentMessageId) {
                        <Dialog
                            onClose={this.handleClose}
                            open={this.state.open}
                        >
                            <DialogTitle>
                                <FormattedMessage id="help.title"/>
                            </DialogTitle>
                            <DialogContent>
                                <div className="side-padding">
                                    <FormattedHTMLMessage id={this.props.contentMessageId}/>
                                </div>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={this.handleClose}>
                                    <FormattedMessage id="buttons.close"/>
                                </Button>
                            </DialogActions>
                        </Dialog>;
                    }
                }}
            </div>
        );
    }
}

HelpButton.propTypes = {
    content: PropTypes.node,
    href: PropTypes.string,
    interactive: PropTypes.bool,
    onClick: PropTypes.func,
    target: PropTypes.string,
    briefMessageId: PropTypes.string.isRequired,
    contentMessageId: PropTypes.string,
    detailedMessageId: PropTypes.string
};

export default HelpButton;


// WEBPACK FOOTER //
// ./src/components/common/button/HelpButton.js